<template>
  <b-modal
      ref="self"
      class="card-form-modal"
      :active="active"
      :custom-class="'dialog mpc'"
      has-modal-card
      trap-focus
      aria-role="dialog"
      aria-modal
      scroll="clip"
      @close="cancel">
    <template>
      <div class="modal-card datetimepicker-modal">
        <section class="modal-card-body">
          <form>
            <b-field class="field">
              <b-datetimepicker
                  v-model="date"
                  placeholder="Click to select date"
                  locale="en-US"
                  inline
                  icon-pack="fal"
              />
            </b-field>
          </form>

        </section>
        <footer class="modal-card-foot buttons is-right">
          <button class="button" type="button" @click="cancel">Cancel</button>
          <button type="submit" class="button is-success" @click="submit">
            OK
          </button>
        </footer>
      </div>
    </template>
  </b-modal>
</template>

<script>

export default {
  name: 'DatetimepickerModal',
  props: {
    active: {
      type: Boolean,
      default: false,
    },
    date: {
      type: Date,
      default: false,
    },
  },
  methods: {
    cancel() {
      this.$emit('close');
    },
    submit() {
      this.$emit('submit', this.date);
    },
  },
};
</script>

<style lang="stylus">
.dialog .datetimepicker-modal.modal-card .modal-card-body .field
  margin-top 0 !important
.datetimepicker-modal
  .datepicker .dropdown-content
    box-shadow none !important
    -webkit-box-shadow none !important
    padding-top 0
  .dropdown-menu
    width 100%
  .dropdown-item
    padding-top 0
</style>
<style scoped lang="stylus">
.modal-card
  border-radius 6px
  &-body
    padding 25px 0 0 0
.field
  margin-top 0 !important
.button
  width 80px
.footer
  padding 0 10px
</style>
